import { format } from 'date-fns';
import { NotificationManager } from 'react-notifications';

import apiURL from'../../../../store/actions/apiURL';

const Types = {
  DEPUTY_CONNECTED: "DEPUTY_CONNECTED",
  DEPUTY_IMPORTING: "DEPUTY_IMPORTING",
  DEPUTY_EMPLOYEES: "DEPUTY_EMPLOYEES",
  DEPUTY_CREATE_AGREEMENT: "DEPUTY_CREATE_AGREEMENT",
  DEPUTY_CREATE_USER: "DEPUTY_CREATE_USER",
  DEPUTY_LINK_USER: "DEPUTY_LINK_USER",
  DEPUTY_GET_USER_LIST: "DEPUTY_GET_USER_LIST",
};

const setDeputyEmployees = ({ employees, links }) => ({
  type: Types.DEPUTY_EMPLOYEES,
  employees,
  links
});


const setConnectedWithDeputy = (connected, needsReconnection) => ({
  type: Types.DEPUTY_CONNECTED,
  connected,
  needsReconnection
});
const setImportingData = (status) => ({
  type: Types.DEPUTY_IMPORTING,
  status
});

const isConnectedWithDeputy = () => {
  return (dispatch, getState) => {

    // console.debug('isConnectedWithDeputy')

    fetch(apiURL + '/deputy/connected', {
      // fetch('http://localhost:3000/report/templates' , {
      credentials: 'include',
      // mode: 'cors',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        // 'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      }
    }).then(response => response.json())
      .then(response => {
        dispatch(setConnectedWithDeputy(response.connected, response.error?.err == "token expired"))
      })
      .catch(function (error) {
        dispatch(setConnectedWithDeputy(false))
      });
  }
}

const checkReportGenerationStatus = (arn) => {
  return (dispatch, getState) => {
    fetch(apiURL + `/settings/describe-execution/${arn}`, {
      credentials: "include",
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(response => response.json())
      .then(data => {

        const finished = data.data.status !== "RUNNING"

        if (finished) {
          if (data.data.status === 'SUCCEEDED') {
            NotificationManager.success("Timesheets have been successfully imported!", "Importing from Deputy");
          } else {
            NotificationManager.error("We encountered an issue importing from Deputy.", "Importing from Deputy");
          }
          dispatch(setImportingData(false))
        } else {
          setTimeout(() => dispatch(checkReportGenerationStatus(arn)), 1000);
        }
      });
  }
};

const importData = (startDate, endDate) => {
  return (dispatch, getState) => {
    if (!startDate || !endDate) {
      NotificationManager.error('Please ensure all dates are inputted!', 'Importing from Deputy')
      return
    }

    const [start, end] = [startDate, endDate].map(item => format(item, 'yyyy-MM-dd'))

    const response = fetch(apiURL + `/deputy/timesheets/${start}/${end}`, {
      // fetch('http://localhost:3000/report/templates' , {
      credentials: 'include',
      // mode: 'cors',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(response => response.json())
      .then(response => {
        const arn = response.data.executionArn;

        setTimeout(() => dispatch(checkReportGenerationStatus(arn)), 1000)
        dispatch(setImportingData(true))
      })
  }
}

const getDeputyEmployees = () => {
  return (dispatch, getState) => {

    console.debug('isConnectedWithDeputy')

    fetch(apiURL + '/deputy/employees', {
      // fetch('http://localhost:3000/report/templates' , {
      credentials: 'include',
      // mode: 'cors',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        // 'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      }
    }).then(response => response.json())
      .then(response => {
        dispatch(setDeputyEmployees(response))
      })
  }
}



const createDeputyEmployee = (input) => {
  return (dispatch, getState) => {

    console.debug('isConnectedWithDeputy')

    fetch(apiURL + '/deputy/add', {
      // fetch('http://localhost:3000/report/templates' , {
      credentials: 'include',
      // mode: 'cors',
      method: 'POST',
      body: JSON.stringify(input),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        // 'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      }
    }).then(response => response.json())
      .then(response => {
        dispatch(deputyLinkUser(response.link))
      })
  }
}


const linkDeputyEmployee = ({ agreement, deputyId }) => {
  return (dispatch, getState) => {

    console.debug('isConnectedWithDeputy')

    fetch(apiURL + '/deputy/link', {
      // fetch('http://localhost:3000/report/templates' , {
      credentials: 'include',
      // mode: 'cors',
      method: 'POST',
      body: JSON.stringify({
        agreement, deputyId
      }),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        // 'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      }
    }).then(response => response.json())
      .then(response => {
        dispatch(deputyLinkUser(response.link))
      })
  }
}

const deputyGetUserList = (userList) => ({
  type: Types.DEPUTY_GET_USER_LIST,
  userList
});

const deputyLinkUser = (user) => ({
  type: Types.DEPUTY_LINK_USER,
  user
});

const deputyCreateUser = (user) => ({
  type: Types.DEPUTY_CREATE_USER,
  user
});

const deputyCreateAgreement = (agreement) => ({
  type: Types.DEPUTY_CREATE_AGREEMENT,
  agreement
});

const Actions = {
  linkDeputyEmployee,
  isConnectedWithDeputy,
  deputyCreateAgreement,
  deputyCreateUser,
  deputyLinkUser,
  deputyGetUserList,
  importData,
  getDeputyEmployees
}

// exports = {
//   Types,
//   Actions
// }

export { Types, Actions }

// exports.Types = Types
// exports.Actions = Actions